module.exports = __webpack_public_path__ + "media/components/country-flag/static/gn-41ea48eb83c07633265fa059dbf135a6.svg";